/* eslint-disable */
import React, { Component, } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Form, DatePicker, Button, Radio, Input, InputNumber,
  message, Select, Tooltip, Popconfirm, Row, Col, Icon,
  Modal, Popover, Avatar
} from 'antd';
import * as apis from '@/apis';
import copy from 'copy-to-clipboard';
import styles from './style.module.scss';
import productStyles from './selectProduct.module.scss'
import * as messageActions from '@/models/messages/actions'
import Upload from './Upload';
import SelectProduct from './SelectProduct';
import * as services from '@/models/orders/services';
import * as utils from 'utils/index'
import debounce from 'lodash/debounce';
const { Option } = Select;

import {
  QuestionCircleOutlined,
} from '@ant-design/icons';

const APP_MODE = process.env.APP_MODE === 'tenant' ? "staff" : "manager"
const isTenantMode = process.env.APP_MODE === 'tenant';
const isManagerMode = process.env.APP_MODE === 'manager';

function Section(props) {
  return (
    <React.Fragment>
      <div className={styles.section}>
        <div className={styles.secTitle}>{props.title}</div>
        <div className={styles.line}></div>
      </div>
      <div>{props.children}</div>
    </React.Fragment>
  );
}

const productMap = { id: '', name: '', num: '', service_type: 1, repair_type: 1, images: [] }
const accessoriesExpressMap = { return_express: '', expressStatus: '', expressNo: '', remark: '' }
let company = []
let expressStatus = []
for (var key in utils.expressCompanyCode) {
  var value = utils.expressCompanyCode[key]
  company.push({ name: value, id: value })
}
for (var key in utils.expressStatusMainCode) {
  var value = utils.expressStatusMainCode[key]
  expressStatus.push({ name: value, id: value })
}


@Form.create()
class OrderForm extends Component {
  state = {
    loading: false,
    is_return: false,
    lxfs: [],
    address: [],
    defaultaddress: null,
    demand: [],
    showCheckResult: false, //检查重复订单 判断是否展示重复的订单提示
    checkMessage: null,
    repOrder: null, //重复的订单号
    defaultdemand: null,
    orderObj: {},//待提交的订单
    tech_tel: [], //厂家默认的技术支持电话
    product_list: [{ ...productMap }], // 产品列表
    accessories_express_list: [],
    visibleBasicModal: false,
    basicModalType: '',
    addProductHistoryList: [],
    addAskHistoryList: []
  };
  handleSubmit = debounce(() => {
    const { editMode, prev_order, order, dispatch } = this.props;
    this.props.form.validateFields((err, values) => {
      // console.log(1111111, values)
      if (err) {
        return console.error(err);
      }

      if (values.product) {
        values.product = values.product._id || values.product;
      }
      if (values.service_time) {
        values.service_time = values.service_time.valueOf();
      }

      if (prev_order) {
        values.prev_order = prev_order._id;
      }
      //values.logistics_mobile && setFieldsValue({logistics_mobile:values.logistics_mobile.join(',')})
      //values.tech_mobile && setFieldsValue({tech_mobile:values.tech_mobile.join(',')})
      //values.contact_mobile && setFieldsValue({contact_mobile:values.contact_mobile.join(',')})
      //values.feedback_demand = values.feedback_demand.join(',')
      //values.return_address = values.return_address.join(',')
      let orderObj = Object.assign({}, values);
      orderObj.tech_mobile = Array.isArray(values.tech_mobile) ? values.tech_mobile.join(',') : values.tech_mobile;
      orderObj.logistics_mobile = Array.isArray(values.logistics_mobile) ? values.logistics_mobile.join(',') : values.logistics_mobile;
      orderObj.contact_mobile = Array.isArray(values.contact_mobile) ? values.contact_mobile.join(',') : values.contact_mobile;
      orderObj.addr_location = { lng: values.lng, lat: values.lat };

      delete orderObj.product_keys
      delete orderObj.accessories_express_keys
      // let flag = false
      // let nextRepairType = null
      orderObj.product_list = orderObj.product_list.map(item => {
        let items = { ...item }
        // if (!flag) {
        //   if (nextRepairType && nextRepairType != item.repair_type) {
        //     flag = true
        //   }
        // }
        // nextRepairType = item.repair_type
        delete items.product
        return items
      })
      // if (flag) {
      //   message.error('多个产品的保修类型应该保持一致');
      //   return false
      // }

      apis.checkSameOrders({ "mobile": orderObj.contact_mobile, "product": values.product }).then(result => {
        if (!editMode && result.length > 0) {
          this.setState({
            showCheckResult: true, checkMessage: <p>联系电话与订单{result[0].order_no}重复<br />请确认是否重复派单！</p>,
            repOrder: result[0].order_no, orderObj: orderObj
          })
        } else {
          const request = editMode ? services.editOrder(order._id, orderObj) : services.createOrder(orderObj);
          request.then(() => {
            if (editMode) {
              dispatch(messageActions.playActionAudio())
            }
            message.success(editMode ? '已修改' : '已创建');
            this.addHistory(values)
            this.props.submit();
          })
            .catch((error) => {
              message.error(error.message || (editMode ? '修改失败' : '创建失败'));
            })
        }
      })
    });
  }, 500);
  addHistory = ({ product_list = [], feedback_demand = '' }) => {
    const maxNum = 10;
    let askHis = []
    let productHis = []
    let askStorage = localStorage.getItem(`${process.env.APP_MODE}_add_ask`)
    let productStorage = localStorage.getItem(`${process.env.APP_MODE}_add_product`)
    try {
      askHis = JSON.parse(askStorage) || []
      productHis = JSON.parse(productStorage) || []
    } catch (error) { }
    product_list.forEach(item => {
      if (productHis.findIndex(val => val._id === item?.product?._id) == -1) {
        productHis.unshift(item?.product)
      }
    });
    if (productHis.length > maxNum) {
      productHis.splice(maxNum, productHis.length - 1);
    }
    if (askHis.findIndex(val => val === feedback_demand) == -1 && feedback_demand) {
      askHis.unshift(feedback_demand)
    }
    if (askHis.length > maxNum) {
      askHis.splice(maxNum, askHis.length - 1);
    }
    localStorage.setItem(`${process.env.APP_MODE}_add_ask`, JSON.stringify(askHis))
    localStorage.setItem(`${process.env.APP_MODE}_add_product`, JSON.stringify(productHis))

  }
  getStaffs = async () => {
    //const { user } = this.props;
    const { order, editMode, user, prev_order } = this.props;
    let result = null;
    if (prev_order) {
      this.setState({ is_return: prev_order.is_return });
      result = await apis.getStaffsByUserId(prev_order.createdBy._id);
    } else if (editMode) {
      result = await apis.getStaffsByUserId(order.createdBy._id);
      this.setState({ is_return: order.is_return });
    } else {
      result = await apis.getStaffs(user.toJS().staff?._id);
    }
    result.feedback_demand.forEach(element => {
      element.is_fault ? this.setState({ defaultdemand: element.demand }) : null
    });
    result.address.forEach(element => {
      element.is_fault ? this.setState({ defaultaddress: element.address }) : null
    });
    if (result.feedback_demand.length > 0) {
      this.setState({ demand: result.feedback_demand || [] });
    }
    if (result.address.length > 0) {
      this.setState({ address: result.address || [] });
    }
    if (result.tenant.tech_tel) {
      let tels = result.tenant.tech_tel.split(/[\s,，]+/)
      this.setState({ tech_tel: tels })
    }
  }
  initData = () => {
    const order = this.props.order || this.props.prev_order;
    const { product_list = [], accessories_express = [], } = order

    if (product_list.length) {
      this.setState({ product_list: product_list });
    }
    if (accessories_express.length) {
      this.setState({ accessories_express_list: accessories_express });
    }
  }
  initHistoryData = async () => {
    let askHis = []
    let productHis = []
    // let productStorage = localStorage.getItem(`${process.env.APP_MODE}_add_product`)
    let askStorage = localStorage.getItem(`${process.env.APP_MODE}_add_ask`)
    try {
      const productHistory = await apis.queryOrdersRecentUse()
      if (Array.isArray(productHistory)) {
        productHis = productHistory?.map(item => item?.product)
      }
      askHis = JSON.parse(askStorage) || []
      // productHis = JSON.parse(productStorage) || []
    } catch (error) { }
    this.setState({
      addProductHistoryList: productHis,
      addAskHistoryList: askHis
    });
  }
  iframeMessage = async (event) => {
    if (window == event.source) {
      return
    }
    const { dataType, selectData } = event.data || {}
    if (dataType === 'addProductSuccess') {
      this.initHistoryData()
    } else if (dataType === 'adddemandSuccess') {
      await this.getStaffs()
      this.props.form.setFieldsValue({ feedback_demand: selectData })
      this.initHistoryData()
    } else if (dataType === 'addaddressSuccess') {
      await this.getStaffs()
      if (this.state.is_return) {
        this.props.form.setFieldsValue({ return_address: selectData })
      }
      this.initHistoryData()
    }
    console.log("html1收到的数据 ", event.data);
  }
  componentDidMount() {
    window.addEventListener("message", this.iframeMessage)

    this.getStaffs()
    if (this.props.editMode) {
      this.initData()
    }
    this.initHistoryData()
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.iframeMessage)
  }
  smartParseAddrText = async (event) => {
    event.preventDefault();
    const { getFieldValue, setFieldsValue } = this.props.form;
    const originText = getFieldValue('address');
    let result;
    try {
      result = await apis.smartParseAddrText(originText);
    } catch (error) {
      return message.error(error.message || '解析失败');
    }
    //提取联系方式
    let lxfs = originText.match(/((0\d{2,3}-\d{7,8})|(1(3\d{2}|4[14-9]\d|5([0-35689]\d|7[1-79])|66\d|7[2-35-8]\d|8\d{2}|9[13589]\d)\d{7}))/g)
    let fjh = originText.match(/(转[0-9]{4})/g)
    if (lxfs && fjh) {
      lxfs[0] += fjh[0]
    }
    if (result.phonenum) {
      if (lxfs) {
        lxfs = lxfs.map(phone => {
          return result.phonenum.includes(phone) ? result.phonenum : phone
        })
      }
    }
    console.log('lxfs', lxfs)
    this.setState({ lxfs: lxfs })
    if (lxfs) {
      this.setState({ tech_tel: Array.from(new Set(this.state.tech_tel.concat(lxfs))) })
    }
    // result.phonenum && setFieldsValue({ contact_mobile: result.phonenum });
    result.person && setFieldsValue({ contact_name: result.person });
    result.detail && setFieldsValue({ addr_detail: result.detail });
    setFieldsValue({ lng: result.lng || 0 });
    setFieldsValue({ lat: result.lat || 0 });
    setFieldsValue({ addr_code: result.town_code || "" });

    if (result.detail) {
      setFieldsValue({
        address: [
          result.province,
          result.city,
          result.county,
          result.town,
          result.detail,
        ]
          .filter(Boolean)
          .join('-'),
      });
    }

    message.success('已解析，请核实解析结果');
  };
  handleChange = event => {
    const val = event.target.value
    this.setState({ is_return: event.target.value });
    if (val) {
      const { getFieldValue, setFieldsValue } = this.props.form;
      setTimeout(() => {
        const returnAddress = getFieldValue('return_address')
        const list = this.state.address.filter(item => item.address == returnAddress);
        if (list[0] && list[0]?.express) {
          setFieldsValue({ return_express: list[0]?.express })
        }
      }, 500);
    }
  };

  render() {
    const { editMode, user } = this.props;
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
    const order = this.props.order || this.props.prev_order;
    const copyOrderNo = () =>
      new Promise(resolve => {
        copy(this.state.repOrder);
        this.setState({ showCheckResult: false });
        message.success("订单号已经拷贝到剪切板")
      });
    const confimOrder = () =>
      new Promise(resolve => {
        this.setState({ showCheckResult: false });
        const request = services.createOrder(this.state.orderObj);
        request.then(() => {
          message.success('已创建');
          this.props.submit();
        })
          .catch((error) => {
            message.error(error.message || ('创建失败'));
          });
      });
    const selectProductChange = (index, e) => {
      const { getFieldValue, setFieldsValue } = this.props.form;
      const productList = getFieldValue('product_list');

      productList[index].id = e ? e._id : ''
      productList[index].name = e ? e?.name : ''
      productList[index].images = e && e.cover ? [{ id: Math.random().toString(36).slice(-8), url: e.cover.split('?')[0] }] : []

      setFieldsValue({
        product_list: productList,
      });
    }
    const addProductDomain = () => {
      const { getFieldValue, setFieldsValue } = this.props.form;
      const keys = getFieldValue('product_keys');
      const nextKeys = keys.concat({ ...productMap });
      setFieldsValue({
        product_keys: nextKeys,
      });
    }
    const removeProductDomain = (k) => {
      const { getFieldValue, setFieldsValue } = this.props.form;
      const keys = getFieldValue('product_keys');
      const list = getFieldValue('product_list');
      if (keys.length === 1) {
        return;
      }
      setFieldsValue({
        product_keys: keys.filter((key, index) => index !== k),
        product_list: list.filter((key, index) => index !== k),
      });
    }
    const addAccessoriesDomain = () => {
      const { getFieldValue, setFieldsValue } = this.props.form;
      const keys = getFieldValue('accessories_express_keys');
      const nextKeys = keys.concat({ ...accessoriesExpressMap });
      setFieldsValue({
        accessories_express_keys: nextKeys,
      });
    }
    const removeAccessoriesDomain = (k) => {
      const { getFieldValue, setFieldsValue } = this.props.form;
      const keys = getFieldValue('accessories_express_keys');
      const list = getFieldValue('accessories_express');
      // if (keys.length === 1) {
      //   return;
      // }
      setFieldsValue({
        accessories_express_keys: keys.filter((key, index) => index !== k),
        accessories_express: list.filter((key, index) => index !== k),
      });
    }

    getFieldDecorator('product_keys', {
      initialValue: this.state.product_list || []
    });
    getFieldDecorator('accessories_express_keys', {
      initialValue: this.state.accessories_express_list || []
    });

    const handleArrivalChange = e => {
      const { getFieldValue, setFieldsValue } = this.props.form;
      console.log('radio checked', e.target.value);
      setFieldsValue({
        is_urgent: e.target.value ? true : false,
        is_arrival: e.target.value
      });

    };

    const handleReturnAddressChange = (e, option) => {
      const { setFieldsValue } = this.props.form;
      const { dataPayType, dataExpress } = option.props || {}

      setFieldsValue({
        return_pay: dataPayType,
        return_express: dataExpress || '无要求',
      });
    }

    const productKeys = getFieldValue('product_keys');
    const accessoriesExpressKeys = getFieldValue('accessories_express_keys');
    const productItems = productKeys.map((item, index) => (
      <div className={styles.productbox} key={index}>
        <Row gutter={16} type="flex">
          <Col span={12}>

            <Row gutter={8}>
              <Col span={18}>
                <Form.Item label="产品" {...formItemLayout} extra="首次使用请先通过‘维护产品’添加产品。">
                  {getFieldDecorator(`product_list[${index}].product`, {
                    initialValue: order?.product_list[index]?.id || '',
                    rules: [
                      { required: true, message: '请选择产品' },
                    ],
                  })(<SelectProduct className={styles.product} onChange={(e) => {
                    selectProductChange(index, e)
                  }} />)}
                </Form.Item>
              </Col>
              <Col span={6}>
                <Popover
                  trigger="click"
                  placement="bottomRight"
                  content={(
                    <div style={{ width: 300 }}>
                      {this.state.addProductHistoryList.map((v, i) => {
                        return (
                          <div className={productStyles.product} key={i}
                            style={{ borderBottom: i < this.state.addProductHistoryList.length - 1 ? '1px solid #efeaea' : '', cursor: 'pointer' }}
                            onClick={() => {
                              const productList = getFieldValue('product_list');
                              productList[index].id = v._id
                              productList[index].name = v?.name
                              productList[index].product = v
                              productList[index].images = v && v.cover ? [{ id: Math.random().toString(36).slice(-8), url: v.cover.split('?')[0] }] : []

                              const keys = getFieldValue('product_keys');
                              keys[index].id = v._id
                              setFieldsValue({
                                product_list: productList,
                                product_keys: keys,
                              });
                            }}
                          >
                            <Avatar shape="square" size={30} className={productStyles.avatar} src={v?.cover}></Avatar>
                            <div className={productStyles.propductName}>{v?.name}</div>
                          </div>
                        )
                      })}
                      {!this.state.addProductHistoryList.length && <p style={{ textAlign: 'center', margin: 0 }}>暂无数据</p>}
                    </div>
                  )}>
                  <Button type="link" style={{ marginTop: 4 }}>最近使用</Button>
                </Popover>
              </Col>
            </Row>
          </Col>
          <Col span={0}>
            <Form.Item label="产品ID" {...formItemLayout}>
              {getFieldDecorator(`product_list[${index}].id`, {
                initialValue: order?.product_list[index]?.id || '',
                // rules: [
                //   { required: true, message: '请输入产品ID' },
                // ],
              })(<Input placeholder="请输入产品ID" />)}
            </Form.Item>
          </Col>
          <Col span={0}>
            <Form.Item label="产品名称" {...formItemLayout}>
              {getFieldDecorator(`product_list[${index}].name`, {
                initialValue: order?.product_list[index]?.name || '',
                // rules: [
                //   { required: true, message: '请输入产品名称' },
                // ],
              })(<Input placeholder="请输入产品名称" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="产品数量" {...formItemLayout}>
              {getFieldDecorator(`product_list[${index}].num`, {
                initialValue: order?.product_list[index]?.num || 1,
                rules: [
                  { required: true, message: '请输入产品数量' },
                ],
              })(<InputNumber placeholder="请输入产品数量" min={1} style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="产品型号" {...formItemLayout}>
              {getFieldDecorator(`product_list[${index}].model`, {
                initialValue: order?.product_list[index]?.model || '',
              })(<Input placeholder="请输入产品型号" style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="服务类型" {...formItemLayout}>
              {getFieldDecorator(`product_list[${index}].service_type`, {
                initialValue: order?.product_list[index]?.service_type || 1,
                rules: [
                  { required: true, message: '请选择服务类型' },
                ],
              })(
                <Radio.Group>
                  <Radio value={1}>安装</Radio>
                  <Radio value={2}>维修</Radio>
                </Radio.Group>
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            {/* {!editMode && ( */}
            {/* <Form.Item label="保修类型" {...formItemLayout}>
              {getFieldDecorator(`product_list[${index}].repair_type`, {
                initialValue: order?.product_list[index]?.repair_type || 1,
                rules: [
                  { required: true, message: '请选择保修类型' },
                ],
              })(
                <Radio.Group>
                  <Radio value={1}>保内</Radio>
                  <Radio value={2}>保外</Radio>
                </Radio.Group>
              )}
            </Form.Item> */}
            {/* )} */}
          </Col>
          <Col span={24}>
            <Form.Item label="图片描述"
              labelCol={{ span: 3 }} wrapperCol={{ span: 21 }}
            >
              {getFieldDecorator(`product_list[${index}].images`, {
                initialValue: order?.product_list[index]?.images || [],
                rules: [
                  { required: true, message: '请上从传图片' },
                ],
              })(<Upload />)}
            </Form.Item>
          </Col>
          <Col span={12}></Col>
        </Row>
        <div className={styles.itembtns}>
          {/* {isTenantMode && <NavLink to="/products" onClick={() => { this.props.submit(); }}>
            <Button type="link" icon="setting">维护产品</Button>
          </NavLink>} */}
          {isTenantMode && <Button type="link" icon="setting" onClick={() => {
            this.setState({
              visibleBasicModal: true,
              basicModalType: 'products'
            });
          }}>维护产品</Button>
          }
          {index < 1 ?
            <Button type="link" icon="plus-square" onClick={() => { addProductDomain() }}>添加产品</Button>
            :
            <Button type="link" icon="delete" onClick={() => { removeProductDomain(index) }}>删除产品</Button>
          }
        </div>
      </div>
    ));
    const accessoriesExpressItems = accessoriesExpressKeys.map((item, index) => (
      <div className={styles.productbox} key={index}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="快递公司" {...formItemLayout}>
              {getFieldDecorator(`accessories_express[${index}].return_express`, {
                initialValue: (order?.accessories_express[index] && order?.accessories_express[index]?.return_express) || null,
                rules: [
                  { required: true, message: '请输入快递公司' },
                ],
              })(<Select showSearch optionFilterProp="title" placeholder="请输入快递公司">
                {
                  company.map(ele => {
                    return <Select.Option key={ele.id} title={ele?.name} value={ele.id}>{ele?.name}</Select.Option>
                  })
                }
              </Select>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="运单号码" {...formItemLayout}>
              {getFieldDecorator(`accessories_express[${index}].expressNo`, {
                initialValue: (order?.accessories_express[index] && order?.accessories_express[index]?.expressNo) || '',
                rules: [
                  { required: true, message: '请输入运单号码' },
                ],
              })(<Input placeholder="请输入运单号码" />)}
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="备注信息" labelCol={{ span: 3 }} wrapperCol={{ span: 21 }}>
              {getFieldDecorator(`accessories_express[${index}].remark`, {
                initialValue: (order?.accessories_express[index] && order?.accessories_express[index]?.remark) || '',
                rules: [
                  // { required: true, message: '请输入备注信息' },
                ],
              })(<Input.TextArea rows={4} placeholder="请输入备注信息" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="运单状态" {...formItemLayout}>
              {getFieldDecorator(`accessories_express[${index}].expressStatus`, {
                initialValue: (order?.accessories_express[index] && order?.accessories_express[index]?.expressStatus) || null,
                rules: [
                  { required: true, message: '请选择运单状态' }
                ],
              })(
                <Select placeholder="请选择运单状态">
                  {
                    expressStatus.map(ele => {
                      return <Select.Option key={ele.id} title={ele?.name} value={ele.id}>{ele?.name}</Select.Option>
                    })
                  }
                </Select>)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <div style={{ textAlign: 'right' }}>
              <Button type="link" icon="delete" onClick={() => { removeAccessoriesDomain(index) }}>删除快递信息</Button>
            </div>
          </Col>
        </Row>
      </div>
    ))

    return (
      <>
        <Form
          className={styles.form}
          onSubmit={(e) => {
            e.preventDefault();
            this.handleSubmit()
          }}
        >
          <div className={styles.formbox}>
            <div style={{ display: 'none' }}>
              {getFieldDecorator('addr_code', {
                initialValue: order?.addr_code,
              })(<Input />)}
              {getFieldDecorator('addr_detail', {
                initialValue: order?.addr_detail,
              })(<Input />)}
            </div>
            <Section title="工单信息">
              {this.props.prev_order && (
                <Form.Item label="前置工单">
                  <b>{order.order_no}</b>
                </Form.Item>
              )}

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="店铺名称">
                    {getFieldDecorator('order_source', {
                      initialValue: order?.order_source,
                    })(<Input placeholder="请输入来源，便于对工单分组" />)}
                  </Form.Item>
                </Col>
                {user?.get('isSeeMaster') == 1 && <Col span={12}>
                  <Form.Item label="工单类型" >
                    {getFieldDecorator('ticket_type', {
                      initialValue: order?.ticket_type || 2,
                      rules: [
                        { required: true, message: '请选择工单类型' },
                      ],
                    })(
                      <Radio.Group>
                        <Radio value={1}>平台选择师傅<Tooltip placement="top"
                          title="商家发布工单，小兵平台指派师傅">
                          <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                        </Tooltip>
                        </Radio>
                        <Radio value={2}>自主选择师傅<Tooltip placement="top"
                          title="商家发布工单，商家自主选择师傅">
                          <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                        </Tooltip></Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>}
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="工单编号">
                    {getFieldDecorator('order_number', {
                      initialValue: order?.order_number,
                      rules: [
                        { required: false, message: '请输入工单编号' },
                      ],
                    })(<Input placeholder="请输入工单编号" />)}
                  </Form.Item>
                </Col>

                {!editMode && (
                  <Col span={12}>
                    <Form.Item label="保修类型">
                      {getFieldDecorator('payer_type', {
                        initialValue: order?.payer_type ? order?.payer_type : 1,
                        rules: [
                          {
                            required: true,
                            message: '请选择保修类型',
                          },
                        ],
                      })(
                        <Radio.Group>
                          <Radio value={1}>保内</Radio>
                          {/* <Radio value={2}>保外</Radio> */}
                        </Radio.Group>
                      )}
                    </Form.Item>
                  </Col>
                )}
              </Row>
              {productItems}



              <Form.Item label="服务内容">
                {getFieldDecorator('desc', {
                  initialValue: order?.desc,
                  rules: [
                    {
                      required: true,
                      message: '请输入服务内容',
                    },
                  ],
                })(<Input.TextArea rows={4} />)}
              </Form.Item>

              <Row gutter={8}>
                <Col span={20}>
                  <Form.Item label="完单图片反馈要求" extra="首次使用请先通过‘维护图片反馈要求’添加反馈要求。">
                    {getFieldDecorator('feedback_demand', {
                      initialValue: order?.feedback_demand || this.state.defaultdemand,
                      rules: [
                        { message: '请输入完单图片反馈要求' }
                      ],
                    })(
                      <Select allowClear={true} maxTagCount={1} style={{ width: '95%' }}>
                        {this.state.demand.map(item => (
                          <Option key={item.demand} title={item.demand} value={item.demand}>{item.demand?.substring(0, Math.min(30, item.demand.length))}</Option>
                        ))}
                      </Select>)}
                    <Tooltip placement="top" title="反馈要求需管理员在工单配置中完成设置，再选择添加">
                      <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                    </Tooltip>
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Popover
                    trigger="click"
                    placement="bottomRight"
                    content={(
                      <div style={{ width: 500 }}>
                        {this.state.addAskHistoryList.map((v, i) => {
                          return (
                            <div className={productStyles.product} key={i}
                              style={{ borderBottom: i < this.state.addAskHistoryList.length - 1 ? '1px solid #efeaea' : '', cursor: 'pointer' }}
                              onClick={() => {
                                setFieldsValue({
                                  feedback_demand: v,
                                });
                              }}
                            >
                              {v}
                            </div>
                          )
                        })}
                        {!this.state.addAskHistoryList.length && <p style={{ textAlign: 'center', margin: 0 }}>暂无数据</p>}
                      </div>
                    )}>
                    <Button type="link" style={{ marginTop: 4 }}>最近使用</Button>
                  </Popover>
                </Col>
              </Row>


              <Row type="flex" justify="space-between">
                <Col>
                  <Form.Item label="是否返件" required>
                    {getFieldDecorator('is_return', {
                      initialValue: order?.is_return ? true : false,
                      rules: [
                        {
                          required: true,
                          message: '请选择服务类型',
                        },
                      ],
                    })(
                      <Radio.Group
                        // value={this.state.is_return}
                        onChange={(event) => { this.handleChange(event) }}
                      >
                        <Radio value={true}>是</Radio>
                        <Radio value={false}>否</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item></Col>
                <Col>
                  {/* {isTenantMode && <NavLink to="/configure" onClick={() => { this.props.submit(); }}>
                    <Button type="link" icon="setting">维护返件地址</Button>
                  </NavLink>} */}
                  {isTenantMode &&
                    <Button type="link" icon="setting" onClick={() => {
                      this.setState({
                        visibleBasicModal: true,
                        basicModalType: 'configure'
                      });
                    }}>维护图片反馈要求/返件地址</Button>
                  }
                </Col>
              </Row>


              {this.state.is_return &&
                <Form.Item label="返件信息" extra="首次使用请先通过‘维护返件地址’添加返件地址。">
                  {getFieldDecorator('return_address', {
                    initialValue: order?.return_address || this.state.defaultaddress,
                    rules: [
                      { required: true, message: '请输入返件信息' },
                    ],
                  })(
                    <Select allowClear={true} style={{ width: '90%' }} placeholder="请选择支付方式" onChange={handleReturnAddressChange}>
                      {this.state.address.map(item => (
                        <Option key={item.address}
                          title={item.address}
                          dataPayType={item.pay_type}
                          dataExpress={item.express}
                          value={item.address}
                        >
                          {item.address}
                        </Option>
                      ))}

                    </Select>)}
                  <Tooltip placement="top" title="返件地址需管理员在工单配置中完成设置，再选择添加">
                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                  </Tooltip>
                </Form.Item>
              }
              {this.state.is_return &&
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="支付方式" >
                      {getFieldDecorator('return_pay', {
                        initialValue: order?.return_pay || 1,
                        rules: [
                          { required: true, message: '请选择支付方式' },
                        ],
                      })(
                        <Select placeholder="请选择支付方式" >
                          <Option title="寄付" value={1}>寄付</Option>
                          <Option title="到付" value={2}>到付</Option>
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="快递公司">
                      {getFieldDecorator('return_express', {
                        initialValue: order?.return_express,
                        rules: [
                          { required: true, message: '请输入快递公司' },
                        ],
                      })(<Input placeholder="请输入快递公司" />)}
                    </Form.Item>
                  </Col>
                </Row>
              }
            </Section>
            <Section title="上门信息">
              <Form.Item label="上门地址" required>
                {getFieldDecorator('address', {
                  initialValue: order?.address,
                  rules: [
                    {
                      required: true,
                      message: '请输入上门地址',
                    },
                  ],
                })(<Input
                  addonAfter={<Button size="small"
                    type="link"
                    onClick={this.smartParseAddrText}>
                    一键智能解析地址
                  </Button>}
                />)}

              </Form.Item>
              <Row gutter={16}>
                <Col span={0}>
                  <Form.Item label="lng">
                    {getFieldDecorator('lng', {
                      initialValue: order?.addr_location?.lng || 0,

                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={0}>
                  <Form.Item label="lat">
                    {getFieldDecorator('lat', {
                      initialValue: order?.addr_location?.lat || 0,

                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="客户姓名" required>
                    {getFieldDecorator('contact_name', {
                      initialValue: order?.contact_name,
                      rules: [
                        {
                          required: true,
                          message: '请输入客户姓名',
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="联系电话" required>
                    {getFieldDecorator('contact_mobile', {
                      initialValue: order?.contact_mobile ? order.contact_mobile.split(',') : [],
                      rules: [
                        {
                          required: true,
                          message: '请输入联系电话',
                        },
                      ],
                    })(<Select mode="tags">
                      {this.state.lxfs?.map(item => (
                        <Select.Option key={item} value={item}>{item?.substring(0, Math.min(30, item.length))}
                        </Select.Option>
                      ))}
                    </Select>)}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="技术电话">
                    {getFieldDecorator('tech_mobile', {
                      initialValue: order?.tech_mobile ? order.tech_mobile.split(',') : []
                    })(<Select mode="tags">
                      {this.state.tech_tel?.map(item => (
                        <Select.Option key={item} value={item}>{item?.substring(0, Math.min(30, item.length))}
                        </Select.Option>
                      ))}
                    </Select>)}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="物流电话">
                    {getFieldDecorator('logistics_mobile', {
                      initialValue: order?.logistics_mobile ? order.logistics_mobile.split(',') : []
                    })(<Select mode="tags">
                      {this.state.lxfs?.map(item => (
                        <Select.Option key={item} value={item}>{item?.substring(0, Math.min(30, item.length))}
                        </Select.Option>
                      ))}
                    </Select>)}
                  </Form.Item>
                </Col>
              </Row>
              {!editMode && (
                <Form.Item label="上门时间" >
                  {getFieldDecorator('service_time')(
                    <DatePicker
                      showTime={{ format: 'HH:mm', minuteStep: 5 }}
                      format="YYYY-MM-DD HH:mm"
                      placeholder="选择上门时间"
                    />
                  )}
                  <Tooltip placement="top" title="初步预计/若不填写则由师傅与客户自行预约">
                    <Icon type="exclamation-circle" style={{ marginLeft: 5 }} />
                  </Tooltip>
                </Form.Item>
              )}

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="是否急单" >
                    {getFieldDecorator(`is_urgent`, {
                      initialValue: typeof order?.is_urgent == 'boolean' ? order?.is_urgent : false,
                      rules: [
                        { required: true, message: '请选择是否急单' },
                      ],
                    })(
                      <Radio.Group>
                        <Radio value={true}>急单</Radio>
                        <Radio value={false}>非急单</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="到货状态">
                    {getFieldDecorator(`is_arrival`, {
                      initialValue: typeof order?.is_arrival == 'boolean' ? order?.is_arrival : false,
                      rules: [
                        { required: true, message: '请选择是否急单' },
                      ],
                    })(
                      <Radio.Group onChange={handleArrivalChange}>
                        <Radio value={false}>未到货</Radio>
                        <Radio value={true}>已到货<span style={{ color: '#999' }}>(到客户家，默认急单)</span></Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item label="是否上楼" >
                    {getFieldDecorator(`is_up`, {
                      initialValue: typeof order?.is_up == 'boolean' ? order?.is_up : false,
                      rules: [
                        { required: true, message: '请选择是否上楼' },
                      ],
                    })(
                      <Radio.Group>
                        <Radio value={true}>上楼</Radio>
                        <Radio value={false}>不上楼</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
                {getFieldValue('is_up') && <>
                  <Col span={12}>
                    <Form.Item label="所在楼层">
                      {getFieldDecorator('floor', {
                        initialValue: order?.floor,
                        rules: [
                          { required: false, message: '请输入所在楼层' },
                        ],
                      })(<Input placeholder="请输入所在楼层" suffix="层" />)}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="有无电梯" >
                      {getFieldDecorator(`is_elevator`, {
                        initialValue: typeof order?.is_elevator == 'boolean' ? order?.is_elevator : true,
                        rules: [
                          { required: true, message: '请选择有无电梯' },
                        ],
                      })(
                        <Radio.Group>
                          <Radio value={true}>有电梯</Radio>
                          <Radio value={false}>无电梯</Radio>
                        </Radio.Group>
                      )}
                    </Form.Item>
                  </Col>
                </>}


                <Col span={12}>
                  <Form.Item label="是否提货" >
                    {getFieldDecorator(`is_pick`, {
                      initialValue: typeof order?.is_pick == 'boolean' ? order?.is_pick : false,
                      rules: [
                        { required: true, message: '请选择是否提货' },
                      ],
                    })(
                      <Radio.Group>
                        <Radio value={true}>提货</Radio>
                        <Radio value={false}>不提货</Radio>
                      </Radio.Group>
                    )}
                  </Form.Item>
                </Col>
              </Row>

              {getFieldValue('is_pick') && <Form.Item label="提货信息">
                {getFieldDecorator('pick_info', {
                  initialValue: order?.pick_info,
                  rules: [
                    { required: true, message: '请输入提货信息' },
                  ],
                })(<Input placeholder="请输入提货信息" />)}
              </Form.Item>}
              <Row gutter={16}>
                <Col span={12}>

                </Col>
                <Col span={12}>
                  <div style={{ textAlign: 'right' }}>
                    <Button type="link" icon="plus-square" onClick={() => { addAccessoriesDomain() }}>添加快递信息</Button>
                  </div>
                </Col>
              </Row>

              {accessoriesExpressItems}



            </Section>
            {editMode && (
              <Section title="处理结果">
                <Form.Item>
                  {getFieldDecorator('workerResult', {
                    initialValue: order?.workerResult,
                  })(<Input.TextArea rows={4} placeholder="请输入处理结果" />)}
                </Form.Item>
              </Section>
            )}
            <Section title="备注">
              <Form.Item>
                {getFieldDecorator('remark', {
                  initialValue: order?.remark,

                })(<Input.TextArea rows={6} placeholder="请输入备注，备注内容师傅不可见" />)}
              </Form.Item>
            </Section>
          </div>
          <div className={styles.btns}>
            {/* <Form.Item
            wrapperCol={{ span: 12, offset: 6 }}
            extra={
              !editMode && (
                <span className={styles.tips}>
                  * 下单后不可更改，如需更改请联系客服
                </span>
              )
            }
          > */}
            <Popconfirm
              title={this.state.checkMessage}
              onConfirm={confimOrder}
              okText="继续下单"
              cancelText="关闭"
              onCancel={copyOrderNo}
              visible={this.state.showCheckResult}
            >

            </Popconfirm>
            <Button type="primary" htmlType="submit">
              {editMode ? '保存修改' : '下单'}
            </Button>
            <Button style={{ marginLeft: '10px' }} onClick={() => {
              this.props.submit();
            }}>
              取消
            </Button>
            {/* </Form.Item> */}
          </div>

        </Form>

        <Modal
          title={(
            <>
              {this.state.basicModalType == 'products' && <span>产品管理</span>}
              {this.state.basicModalType == 'configure' && <span>工单配置</span>}
            </>
          )}
          visible={this.state.visibleBasicModal}
          width={1300}
          bodyStyle={{ height: '80vh' }}
          footer={null}
          onCancel={() => {
            this.setState({
              visibleBasicModal: false,
              basicModalType: ''
            });
          }}
        >
          <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
            {this.state.basicModalType == 'products' && <iframe src="/iframe-products" width="100%" height="100%" frameBorder="0"></iframe>}
            {this.state.basicModalType == 'configure' && <iframe src="/iframe-configure" width="100%" height="100%" frameBorder="0"></iframe>}
          </div>
        </Modal>

      </>
    );
  }
}

export default OrderForm;
